'use strict';

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var debug = require('debug');

var log = debug('libp2p:websocket-star:multi');

var once = require('once');

var EE = require('events').EventEmitter;

var _require = require('async'),
    map = _require.map,
    parallel = _require.parallel;

var multiaddr = require('multiaddr');

var mafmt = require('mafmt');

var WSStar = require('libp2p-websocket-star');

var WebsocketStarMulti =
/*#__PURE__*/
function () {
  // listen on multiple websocket star servers without having to worry about one being down.
  // NOTE: if no servers are reachable or provided an error is thrown
  function WebsocketStarMulti(opt) {
    _classCallCheck(this, WebsocketStarMulti);

    this.opt = opt || {};
    this.servers = opt.servers || [];
    this.ws = new WSStar(this.opt);
    this.discovery = this.ws.discovery;
  }

  _createClass(WebsocketStarMulti, [{
    key: "dial",
    value: function dial(ma, opt, cb) {
      log('dial', ma);
      return this.ws.dial(ma, opt, cb);
    }
  }, {
    key: "createListener",
    value: function createListener(options, handler) {
      var _this = this;

      if (typeof options === 'function') {
        handler = options;
        options = {};
      }

      var listener = new EE();
      listener.servers = {};
      listener.online = [];
      this.servers.forEach(function (ser) {
        var s = _this.ws.createListener(options, handler);

        s.once('error', function () {});
        s.url = ser;
        listener.servers[ser] = s;
      });

      listener.listen = function (ma, cb) {
        var id = ma.toString().split('ipfs/').pop();
        log('listen on %s server(s) with id %s', _this.servers.length, id);
        parallel(_this.servers.map(function (url) {
          return listener.servers[url];
        }).map(function (server) {
          return function (cb) {
            log('listen %s', server.url);
            var next = once(function (err) {
              log('listen %s ok %s', server.url, !err);
              if (err) return cb(log(err));
              listener.online.push(server);
              return cb();
            });
            setTimeout(next, _this.opt.timeout || 5000, new Error('Timeout'));
            server.listen(multiaddr(server.url).encapsulate('/ipfs/' + id), next);
          };
        }), function () {
          if (!listener.online.length && !_this.opt.ignore_no_online) {
            var e = new Error("Couldn't listen on any of the servers");
            listener.emit('error', e);
            cb(e);
          } else {
            listener.emit('listening');
            cb();
          }
        });
      };

      listener.close = function (cb) {
        return parallel(listener.online.map(function (s) {
          return function (cb) {
            return s.close(cb);
          };
        }), function (err) {
          return cb(err, listener.online = []);
        });
      };

      listener.getAddrs = function (cb) {
        return map(listener.online, function (s, n) {
          return s.getAddrs(n);
        }, function (err, res) {
          if (err) return cb(err);
          return cb(null, res.reduce(function (a, b) {
            return a.concat(b);
          }, []));
        });
      };

      return listener;
    }
  }, {
    key: "filter",
    value: function filter(ma) {
      if (!Array.isArray(ma)) ma = [ma];
      return ma.filter(function (ma) {
        return ma.toString().startsWith('/p2p-websocket-star') || mafmt.WebSocketStar.matches(ma);
      });
    }
  }]);

  return WebsocketStarMulti;
}();

module.exports = WebsocketStarMulti;